"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var MailOutline_exports = {};
__export(MailOutline_exports, {
  default: () => MailOutline_default
});
module.exports = __toCommonJS(MailOutline_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.46484 4.07812H16.5156C16.9323 4.07812 17.2839 4.22786 17.5703 4.52734C17.8698 4.8138 18.0195 5.16536 18.0195 5.58203V14.8398C18.0195 15.2435 17.8698 15.5951 17.5703 15.8945C17.2839 16.181 16.9323 16.3242 16.5156 16.3242H4.46484C4.04818 16.3242 3.6901 16.181 3.39062 15.8945C3.10417 15.5951 2.96094 15.2435 2.96094 14.8398V5.58203C2.96094 5.16536 3.10417 4.8138 3.39062 4.52734C3.6901 4.22786 4.04818 4.07812 4.46484 4.07812ZM3.95703 5.58203V6.28516L10.168 10.4258C10.2591 10.4909 10.3633 10.5234 10.4805 10.5234C10.6107 10.5234 10.7214 10.4909 10.8125 10.4258L17.0234 6.28516V5.58203C17.0234 5.4388 16.9714 5.32161 16.8672 5.23047C16.776 5.1263 16.6589 5.07422 16.5156 5.07422H4.46484C4.32161 5.07422 4.19792 5.1263 4.09375 5.23047C4.0026 5.32161 3.95703 5.4388 3.95703 5.58203ZM3.95703 7.30078V14.8398C3.95703 14.9701 4.0026 15.0872 4.09375 15.1914C4.19792 15.2826 4.32161 15.3281 4.46484 15.3281H16.5156C16.6589 15.3281 16.776 15.2826 16.8672 15.1914C16.9714 15.0872 17.0234 14.9701 17.0234 14.8398V7.30078L11.2812 11.1289C11.0339 11.2852 10.7669 11.3633 10.4805 11.3633C10.207 11.3633 9.94661 11.2852 9.69922 11.1289L3.95703 7.30078Z",
      fill: "currentColor"
    }
  )
);
const SvgMailOutline = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var MailOutline_default = SvgMailOutline;
